module.exports = __webpack_public_path__ + "static/media/calendar-selected.05119033.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/calendar-selected.svg
// module id = 773
// module chunks = 0